import { render } from "./AddUser.vue?vue&type=template&id=044da2ee"
import script from "./AddUser.vue?vue&type=script&lang=js"
export * from "./AddUser.vue?vue&type=script&lang=js"

import "./AddUser.vue?vue&type=style&index=0&id=044da2ee&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/addUser/AddUser.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "044da2ee"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('044da2ee', __exports__)) {
    console.log('reload')
    api.reload('044da2ee', __exports__)
  }
  
  module.hot.accept("./AddUser.vue?vue&type=template&id=044da2ee", () => {
    console.log('re-render')
    api.rerender('044da2ee', render)
  })

}


export default __exports__